import { Typography, TypographyProps } from '@mui/material';

import { COLORS } from '@/styles/tokens/colors';

/**
 * Typography component for use in menu items, ensuring consistent styling (color, variant)
 * for dropdown and select options throughout the app.
 * Use this instead of MUI Typography directly when rendering text inside menu or select items.
 */
export function MenuItemTypography(props: Partial<TypographyProps>) {
  return (
    <Typography variant="body-xs" color={COLORS.TEXT.PRIMARY} {...props} />
  );
}
